// dictionary keys

export const en = (isShortFormType) => {
    return {
        accessReport: "Access Report",
        download: "Download",
        email: isShortFormType ? "Email" : "Business Email",
        firstName: "First Name",
        invalidDomain: "Please enter a company email address instead of a personal one",
        invalidEmail: "Please enter a valid email address",
        invalidMissingFields: "Please fill all the fields",
        lastName: "Last Name",
        loginToView: "Login to View",
        newsletterSub: "Keep me updated with the latest startup news",
        selectLocation: "Select Location",
        selectRole: "Select Role",
        companyName: "Company Name",
        jobTitle: "Job Title",
        companyType: "Company Type",
        generalError: "Something went wrong, please try again or contact us for help",
        requestAccess: "Access Through Subscription",
        whatsInThisReport: "What's in this report",
        whatsInThisReport_free: "Free version of this report",
        whatsInThisReport_paid: "Premium version of this report",
    }
}

export const ar = (isShortFormType) => {
    return {
        accessReport: "تحميل التقرير",
        download: "تحميل",
        email: isShortFormType ? "البريد الإلكتروني" : "بريد العمل",
        firstName: "الاسم الأول",
        invalidDomain: "الرجاء إدخال بريد إلكتروني للعمل بدلاً عن البريد الشخصي",
        invalidEmail: "الرجاء إدخال بريد إلكتروني صالح",
        invalidMissingFields: "الرجاء تعبئة جميع الحقول",
        lastName: "اسم العائلة",
        loginToView: "تسجيل الدخول",
        newsletterSub: "الإشتراك بآخر أخبار الشركات الناشئة",
        selectLocation: "البلد",
        selectRole: "منصب العمل",
        companyName: "اسم الشركة",
        jobTitle: "منصب العمل",
        companyType: "شركة",
        generalError: "حدث خطأ ما. يرجى المحاولة مرة أخرى أو الاتصال بنا للحصول على المساعدة",
        requestAccess: "الوصول من خلال الاشتراك",
        whatsInThisReport: 'ماذا يتضمن هذا التقرير',
        whatsInThisReport_free: "نسخة مجانية من هذا التقرير",
        whatsInThisReport_paid: "النسخة المتقدمة من هذا التقرير",
    }
}
